/* Copyright (c) 2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

interface FooterLink {
    labelKey: string;
    href: string;
}

@Component({
    selector: 'nv-common-footer',
    templateUrl: './common-footer.component.html',
    styleUrls: ['./common-footer.component.scss'],
    standalone: true,
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonFooterComponent {
    readonly footerLinks: FooterLink[] = [
        {
            labelKey: 'footer.privacyPolicy',
            href: 'https://www.nvidia.com/en-us/about-nvidia/privacy-policy/'
        },
        {
            labelKey: 'footer.yourPrivacyChoices',
            href: 'https://www.nvidia.com/en-us/about-nvidia/privacy-center/'
        },
        {
            labelKey: 'footer.termsOfService',
            href: 'https://www.nvidia.com/en-us/about-nvidia/terms-of-service/'
        },
        {
            labelKey: 'footer.accessibility',
            href: 'https://www.nvidia.com/en-us/about-nvidia/accessibility/'
        },
        {
            labelKey: 'footer.corporatePolicies',
            href: 'https://www.nvidia.com/en-us/about-nvidia/company-policies/'
        },
        {
            labelKey: 'footer.productSecurity',
            href: 'https://www.nvidia.com/en-us/product-security/'
        },
        {
            labelKey: 'footer.contact',
            href: 'https://www.nvidia.com/en-us/contact/'
        }
    ];
}
